import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4 4.75V14.4057L6.08221 12.7223C6.26016 12.5785 6.48207 12.5 6.7109 12.5H15.5V4.75H4ZM2.51256 3.26256C2.84075 2.93438 3.28587 2.75 3.75 2.75H15.75C16.2141 2.75 16.6592 2.93437 16.9874 3.26256C17.3156 3.59075 17.5 4.03587 17.5 4.5V12.75C17.5 13.2141 17.3156 13.6592 16.9874 13.9874C16.6592 14.3156 16.2141 14.5 15.75 14.5H7.06456L3.62868 17.2777C3.32903 17.5199 2.91684 17.5684 2.56912 17.4024C2.22139 17.2364 2 16.8853 2 16.5V4.5C2 4.03587 2.18438 3.59075 2.51256 3.26256Z",
      fill: "#A466FC"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.5 8.25C15.5 7.69772 15.9477 7.25 16.5 7.25H20.25C20.7141 7.25 21.1592 7.43437 21.4874 7.76256C21.8156 8.09075 22 8.53587 22 9V21C22 21.3853 21.7786 21.7364 21.4309 21.9024C21.0832 22.0684 20.671 22.0199 20.3713 21.7777L16.9354 19H8.25C7.78587 19 7.34075 18.8156 7.01256 18.4874C6.68437 18.1592 6.5 17.7141 6.5 17.25V13.5C6.5 12.9477 6.94772 12.5 7.5 12.5C8.05228 12.5 8.5 12.9477 8.5 13.5V17H17.2891C17.5179 17 17.7398 17.0785 17.9178 17.2223L20 18.9057V9.25H16.5C15.9477 9.25 15.5 8.80228 15.5 8.25Z",
      fill: "#A466FC"
    }, null, -1)
  ])))
}
export default { render: render }